import { FormGroup, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rejection-reason',
  templateUrl: './rejection-reason.component.html',
  styleUrls: ['./rejection-reason.component.scss']
})
export class RejectionReasonComponent implements OnInit {
  @ViewChild('docRejectForm') docRejectForm: FormGroupDirective;
  @Input('orderAction') orderAction;
  @Input('orderUuid') orderUuid;
  @Input('orderStatus') orderStatus;
  @Input('orderFrom') orderFrom;
  submitted: boolean = false;
  rejectForm = new FormGroup({
    reason: new FormControl('', [Validators.required]),
  });

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef
  ) {
  }

  ngOnInit() {
    this.rejectForm.controls['reason'].setValue(null);
  }

  submit() {
    console.log(this.rejectForm)
    if (this.rejectForm.valid) {
      let fd: any = this.rejectForm.value;
      this.orderAction.emit({ uuid: this.orderUuid, action: this.orderStatus, rejected_reason: fd.reason, from: this.orderFrom });
      this.activeModal.dismiss();
    }
  }

}
